import React from "react";
import styled from "styled-components";
import { HiX } from "react-icons/hi";
import { CheckboxWrapper, CheckIcon, CustomCheckbox, HiddenCheckbox } from "./DataTable.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
    border: 1px solid #1F1F1F;
    padding: 12px;
  font-family: 'Onest', sans-serif;
  background-color: rgba(255, 255, 255, 0.05);
    gap: 4px;
    min-width: 420px;
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 400;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;



const CountText = styled.span`
  font-weight: 500;
`;

export const ActionButton = styled.button`
  padding: 4px 12px 4px 12px;
  font-family: 'Onest', sans-serif;
  background-color: #1B1B1C;
  color: gray;
  border: none;
  border-radius: 16px;

  cursor: pointer;
  font-weight: 500;
  font-size: 13px;

         @media (max-width: 768px) {
    font-size: 12px;
    margin-right: -15px;
    
  }

  transition: 0.2s;

  &:hover {
    color: var(--text-active-color);
    transition: 0.2s;
    }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
    padding: 4px 12px 4px 12px;
  font-family: 'Onest', sans-serif;
  background-color: #1B1B1C;
  color: gray;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 2px;
transition: 0.2s;
  &:hover {
    color: var(--text-active-color);
    transition: 0.2s;
  }
`;

interface MultiSelectInfoProps {
  count: number;
  allSelected: boolean;
  onSelectAll: () => void;
  onAction: () => void;
  onClose: () => void;
  actionLabel: string;
}

export const MultiSelectInfo: React.FC<MultiSelectInfoProps> = ({
  count,
  allSelected,
  onSelectAll,
  onAction,
  onClose,
  actionLabel,
}) => {

  return (
    <Wrapper>
      <Row>
          <CountText>Выбрано: {count}</CountText>
          <LeftGroup>
          <CheckboxWrapper>
            <HiddenCheckbox checked={allSelected} onChange={(allSelected ? onClose : onSelectAll)} />
            <CustomCheckbox checked={allSelected}>
              <CheckIcon />
            </CustomCheckbox>
          </CheckboxWrapper>
          <span style={{ cursor: "pointer" }} onClick={(allSelected ? onClose : onSelectAll)}>Выбрать всё</span>
        </LeftGroup>
      </Row>

      {/* второй ряд */}
      <Row>
        <ActionButton onClick={onAction}>{actionLabel}</ActionButton>
        <CloseButton onClick={onClose}><HiX /></CloseButton>
      </Row>
    </Wrapper>
  );
};
